import { http } from "./Config";
import settings from "@/settings";
export default {
  
  list: () => {
    return http.get(
      "api/isapi.dll/syspedgetrecdoc" +
      "?empresa=" + settings.usuarioAutenticado.EMPRESA +
      "&cliente=" + settings.usuarioAutenticado.CLIENTE
    );
  },
  registraPagamento: (pagamento) => {
    return http.post(
      "api/isapi.dll/syspedrecdocpagamento" + 
      "?empresa=" + settings.usuarioAutenticado.EMPRESA +
      "&cliente=" + settings.usuarioAutenticado.CLIENTE,
      pagamento
    );
  },
  enviaComprovante: (idPagamento, comprovante, extensao) => {
    return http.post(
      "api/isapi.dll/syspedrecdoccomprovante" + 
      "?empresa=" + settings.usuarioAutenticado.EMPRESA +
      "&cliente=" + settings.usuarioAutenticado.CLIENTE +
      "&id_pgto=" + idPagamento +
      "&ext_arq=" + extensao ,
      comprovante
    );
  },
  listPagamentos: (tipoDoc, nrDoc, parcela) => {
    return http.get(
      "api/isapi.dll/syspedrecdocpagamento" +
      "?empresa=" + settings.usuarioAutenticado.EMPRESA +
      "&cliente=" + settings.usuarioAutenticado.CLIENTE +
      "&tipo_doc=" + tipoDoc +
      "&nr_doc=" + nrDoc +
      "&parcela=" + parcela
    );
  },
  downloadComprovante: (idPagamento) => {
    return http.get(
      "api/isapi.dll/syspedrecdoccomprovante" +
      "?empresa=" + settings.usuarioAutenticado.EMPRESA +
      "&cliente=" + settings.usuarioAutenticado.CLIENTE +
      "&id_pgto=" + idPagamento
    );
  },
};
